<ion-header>
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content>
  
  <div class="big-emojis disconnected-visual-container">
    <img src="assets/png/satellite-antenna.png" alt="EnvoitureSimone">
    <!-- 📡 -->
    <!-- <div class="light-container">
      <div class="arrow"></div>
      <div class="light-content">
        <i class="icon ion-ios-wifi"></i>
      </div>
      <div class="torch"></div>
    </div> -->
  </div>
  <div class="oups-txt">Oups !<br>Ta connexion Internet<br>est introuvable</div>
  <div class="tips-txt callout">
    <span *ngIf="true">Tu dois être connecté à Internet<br>pour accéder à cette page.</span>
  </div>
  <div *ngIf="!storageLocked" class="btn-container">
    <button class="btn" [ngClass]="{'full-width margin-top-30': !isDesktop, 'wpi-200 margin-top-40': isDesktop}" (click)="reloadLink()">Réessayer ⚡</button>
    <!-- <br>
    Page attendue : {{offline_lastLink | json}} -->
  </div>
  
</ion-content>

<ion-footer>
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>